export default __webpack_public_path__ + "static/media/money-time.f787a77a.webp";